<template>
  <v-select
    class="user-select"
    :multiple="multiple"
    :filterable="false"
    label="objectID"
    :options="options"
    placeholder="Search Users"
    :value="value"
    @input="$emit('input', $event)"
    @search="searchUsersHandler"
  >
    <template slot="no-options">
      <div class="content user-select__hint">
        <span v-if="query">
          No matching results
        </span>
        <span v-else>
          Type to search users...
        </span>
      </div>
    </template>
    <template slot="option" slot-scope="option">
      <!-- eslint-disable-next-line -->
      <div class="content">{{ displayDetails(option) }}</div>
    </template>
    <template slot="selected-option" slot-scope="option">
      <div class="content">
        {{ displayDetails(option) }}
      </div>
    </template>
  </v-select>
</template>

<script>
import debounce from 'lodash/debounce';
import { displayDetails } from '../../utils/user';

export default {
  props: {
    value: {
      type: [Array, Object],
      default: null,
      required: false
    },
    multiple: {
      type: Boolean,
      default: false
    },
    filters: {
      type: String,
      required: false
    }
  },
  data: function() {
    return {
      options: [],
      query: ''
    };
  },
  methods: {
    displayDetails,
    searchUsersHandler(search, loading) {
      loading(true);
      this.searchUser(search, loading);
    },
    searchUser: debounce(function(search, loading) {
      this.query = search;
      const index = this.$searchClient.initIndex('users');
      index.search(
        {
          query: search,
          hitsPerPage: 5,
          attributesToRetrieve: [
            'childName',
            'guardianName',
            'email',
            'phoneNumber'
          ],
          ...(this.filters ? { filters: this.filters } : {})
        },
        (error, data) => {
          if (error) {
            this.$buefy.toast.open({
              message: 'Failed to search for flow tags!',
              type: 'is-danger'
            });
          } else {
            this.options = data.hits.map(hit => ({ ...hit, id: hit.objectID }));
          }
          loading(false);
        }
      );
    }, 400)
  }
};
</script>

<style lang="scss" scoped>
.user-select {
  min-width: 12rem;

  &__hint {
    padding: 0.5rem;
  }
}
</style>
